<script>
export default {
  data() {
    return {
      list: [
        {
          title: '業務洽詢',
          name: 'inquiry',
        },
        {
          title: '聯絡銷售人員',
          name: 'contactSales',
        },
        {
          title: '營業據點',
          name: 'location',
        },
        {
          title: '維修服務',
          name: 'repair',
        },
        {
          title: '會員帳號服務',
          name: 'inquiryOther',
        },
      ],
    }
  },
}
</script>
<template>
  <BaseLayout :menu-list="list" :img="require('@assets/images/contact/banner.png')" custom-class="isStyleWhite">
    <slot />
  </BaseLayout>
</template>
<style lang="scss" module>
</style>
